export default __webpack_public_path__ + "static/media/textlayer_color.4649af1f.jpg";